// This file is used to help us with Matching Survey migrations into the survey framework.
// we need backwards compatibility for our existing question templates, but ideally we integrate
// the two in a better way going forward.

interface Option {
  text: string;
  image?: string;
  oid: string;
  value?: boolean;
}

interface SurveyQuestionSelectOption {
  id: string;
  label: string;
}

interface SurveyQuestionSelectOtherOption {
  id: string | undefined;
  label: string | undefined;
}

function getOptionText(option: string | Option | undefined): string | undefined {
  if (option) {
    return typeof option === "string" ? option : option.text;
  }
  return undefined;
}
function getOptionLabel(
  option: string | SurveyQuestionSelectOption | undefined,
): string | undefined {
  if (option) {
    return typeof option === "string" ? option : option.label;
  }
  return undefined;
}

function getOptionOid(option: string | Option | undefined): string | undefined {
  if (option) {
    return typeof option === "string" ? option : option.oid;
  }
  return undefined;
}

function getOptionObjectFromText(
  optionText: string,
  optionList: (string | Option)[],
): string | Option | undefined {
  return optionList.find(
    (option) => (typeof option === "string" ? option : option.text) === optionText,
  );
}

function selectedOptionPresent(selectedOption: string | Option | undefined): boolean {
  if (typeof selectedOption === "string") {
    return selectedOption.length > 0;
  } else {
    return !!selectedOption?.oid;
  }
}

export {
  getOptionText,
  getOptionLabel,
  getOptionObjectFromText,
  getOptionOid,
  selectedOptionPresent,
};
export type { Option, SurveyQuestionSelectOption, SurveyQuestionSelectOtherOption };
